import { formattedCents } from "source/giving/utils/money"
import { InKindDonation } from "../../types"
import { Badge, Heading } from "@planningcenter/doxy-web"
import { useGivingPersonContext } from "../../hooks/useGivingPersonContext"
import { dateStampStringToLocal } from "source/giving/donate/form/utils/frequency"

interface InKindDonationDetailsProps {
  inKindDonation: InKindDonation
}

export default function InKindDonationDetails({
  inKindDonation,
}: InKindDonationDetailsProps) {
  const { givingPerson } = useGivingPersonContext()

  return (
    <div className="d-f fd-c g-2">
      <div className="d-f fd-c g-1 action-drawer mb-2">
        <div className="d-f ai-c jc-sb fw-w">
          <Heading
            level={3}
            size={4}
            text={dateStampStringToLocal(inKindDonation.received_on)}
            color="tint1"
          />
          <span className="fw-600">{inKindDonation.description}</span>
        </div>
        <div className="d-f fd-c g-1">
          <div className="d-f jc-sb fs-4 c-tint2">
            <div className="d-f g-1 ai-c">
              <Badge text={inKindDonation.fund.name} />
              {givingPerson.has_joint_giver && (
                <span>
                  {inKindDonation.person.first_name}{" "}
                  {inKindDonation.person.last_name}
                </span>
              )}
            </div>
            {inKindDonation.fair_market_value_cents && (
              <span>
                {formattedCents(inKindDonation.fair_market_value_cents)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
